import React from "react";
import "./ServiceDetails.css";

export default function ServiceDetails({ ServiceImage, ServiceName, Description }) {
  return (
    <div className="service-details">
      <div className="service-details-container">
        {/* Image Section */}
        <div className="service-details-image">
          <img src={ServiceImage} alt={ServiceName} className="service-img" />
        </div>

        {/* Text Section */}
        <div className="service-details-content">
          <h1 className="service-heading">{ServiceName}</h1>
          <p className="service-description">{Description}</p>
        </div>
      </div>
    </div>
  );
}
